'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* flow */

var cleanStateKey = function cleanStateKey(key) {
  return key === null || typeof key === 'undefined' ? 'main' : key.toString();
};

exports.default = cleanStateKey;


//////////////////
// WEBPACK FOOTER
// ./~/radium/lib/clean-state-key.js
// module id = 388
// module chunks = 114276838955818